import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

export function* getAlumni() {
    yield* takeEvery("ALUMNI/FETCH", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/alumni${id ? `/${id}` : ''}`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { alumni, alumnis } = result;
                if (action.id) {
                    yield put({ type: 'ALUMNI/SET', alumni });
                } else {
                    yield put({ type: 'ALUMNIS/SET', alumnis });
                }
            } else {
                yield put({
                    type: 'ALUMNI/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'ALUMNI/FETCH_FAILED',
                e
            });
        }
    });
}


// WEBPACK FOOTER //
// ./src/redux-sagas/sagas/alumni.js